import $ from 'jquery';
import appAjax from '../helpers/ajax';

function VaultList({ vaults, page }) {
    return (
        <tbody>
            {vaults.map(vault => (

                <tr key={vault.created_at} className="vault_item" data-uuid={vault.uuid}>
                    <td>
                        <a href="#" target="_blank" className='vault_link'>
                            <i className="fa fa-file" /> <span className='vault_title'>{vault.title}</span>
                        </a>
                    </td>
                    <td style={{ textAlign: "right" }}>
                        <small className='text-muted'><i className="fa fa-calendar"></i> {vault.updated_at || vault.created_at}</small>
                    </td>
                </tr>
            ))}
        </tbody>
    );
}

export function initVaultList(dom, params) {
    $(dom).find('.vault_link').off('click').on('click', function (e) {
        e.preventDefault();
        var elParent = $(this).closest('.vault_item');
        var vaultUuid = elParent.data('uuid');
        var vaultTitle = elParent.find('.vault_title').text();
        
        params.openVault({
            uuid: vaultUuid,
            title: vaultTitle
        });
    });
};

export default VaultList;
